import { Button, styled, Tooltip, tooltipClasses, TooltipProps, Typography } from '@mui/material';

export const ContentW = styled('div')`
  width: calc(100% - 38px);
  padding: 40px 0px;
  border-radius: 15px;
  @media (max-width: 1023px) {
    width: 100%;
    padding: 0px;
    margin-top: 8px;
  }
`;

export const SectionTitle = styled(Typography)`
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: ${({ theme }) => theme.palette.primary.p080};
  margin-bottom: 12px;
  padding-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 12px;

  &::after {
    content: '';
    flex: 1;
    height: 1px;
    background: ${({ theme }) => theme.palette.grey[300]};
  }

  @media (max-width: 1023px) {
    font-size: 18px;
    margin-bottom: 8px;
  }
`;

export const ContainerTitle = styled(Typography)`
  font-weight: 500;
  font-size: 24px;
  line-height: 24px;
  color: ${({ theme }) => theme.palette.primary.p080};
  margin-bottom: 16px;
`;

export const ActionItem = styled('div')<{ isBlocked: boolean }>`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  height: 124px;
  padding: 20px;
  background: ${({ theme }) => theme.palette.white.main};
  opacity: ${({ isBlocked }) => (isBlocked ? '0.5' : '1')};
  color: ${({ theme }) => theme.palette.primary.p080};
  border-radius: 15px;
  border: 1.5px solid ${({ theme }) => theme.palette.grey[200]};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: ${({ theme }) => theme.palette.info.main};
    transform: translateY(-2px);
  }

  @media (max-width: 1023px) {
    &:hover {
      transform: none;
    }
  }
`;

export const ActionIconWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  border-radius: 10px;
  background: ${({ theme }) => theme.palette.grey[100]};

  svg {
    width: 28px;
    height: 28px;
  }

  img {
    width: 28px;
    height: 28px;
    object-fit: contain;
  }

  @media (max-width: 1023px) {
    width: 42px;
    height: 42px;
    border-radius: 8px;

    svg {
      width: 24px;
      height: 24px;
    }

    img {
      width: 24px;
      height: 24px;
    }
  }
`;

export const ActionTextWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
`;

export const ActionLabel = styled(Typography)`
  font-weight: 600;
  font-size: 15px;
  line-height: 20px;
  color: ${({ theme }) => theme.palette.primary.p080};
`;

export const ActionDescription = styled(Typography)`
  font-weight: 400;
  font-size: 14px;
  line-height: 18px;
  text-align: left;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const ActionsList = styled('div')`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(358px, 1fr));
  row-gap: 8px;
  column-gap: 8px;
  margin-bottom: 28px;

  @media (max-width: 1023px) {
    grid-template-columns: 1fr;
  }
`;

export const ButtonW = styled(Button)`
  padding: 0px;
  border-radius: 8px;
  width: 100%;
  height: 124px;
  min-width: unset;
  text-transform: none;
  display: block;

  @media (max-width: 1023px) {
    width: 100%;
    height: auto;
    border-radius: 8px;
  }
`;

export const LogoImage = styled('img')`
  width: 30px;
  height: 30px;
  display: block;
  @media (max-width: 1023px) {
    width: 24px;
    height: 24px;
  }
`;

export const TooltipW = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.info.light,
    color: theme.palette.primary.p080,
    boxShadow: '0px 3px 6px -3px rgba(23, 24, 24, 0.08), 0px 8px 20px -4px rgba(23, 24, 24, 0.12)',
    borderRadius: '4px',
    fontSize: '16px',
    maxWidth: 340,
    padding: '4px 8px',
    margin: 0,
    left: 0,
    bottom: 0,
    right: 'unset',
  },
}));
